import { startOfDay } from "date-fns";

/**
 * The observations that belong on the printable report: reviewed, visible to
 * parents, and on or after the "from" date. Newest first.
 *
 * Shared so the printed report and the AI summary always work from exactly the
 * same set of observations.
 */
export const filterReportObservations = (observations: any[], fromDate?: Date | null) => {
  const from = fromDate ? startOfDay(fromDate) : undefined;

  return (observations || [])
    .filter((observation: any) => observation.reviewed && observation.visibleToParents)
    .filter((observation: any) => !from || new Date(observation.observationDate) >= from)
    .sort((a: any, b: any) => (new Date(b.observationDate) as any) - (new Date(a.observationDate) as any));
};
